import type { App } from '@grafikr/components';

import Cart from 'utils/cart';

export default (app: App) => {
  document.addEventListener('cart:added', () => {
    Cart.get({
      success: (body) => {
        theme.cart = body;
        app.context.dispatchEvent('cart:updated', body);
      },
    });
  });
};
